<template>
  <pt-production-task-detail class="pt-production-task-detail__page" :id="id"></pt-production-task-detail>
</template>

<script>
import PtProductionTaskDetail from 'cps/production-task/pt-production-task-detail/withData'
export default {
  name: 'pt-production-task-detail__view',
  components: {
    'pt-production-task-detail': PtProductionTaskDetail
  },
  props: {
    id: {
      type: String,
      required: true
    },
  }
}
</script>
